(function () {
  'use strict';

  var API = 'https://biblionepal.app/api/store/hours';
  var CACHE_KEY = 'bn-store-hours';
  var CACHE_MS = 10 * 60 * 1000;
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var SHORT_DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  function minutesOf(t) {
    var p = String(t).split(':');
    return parseInt(p[0], 10) * 60 + parseInt(p[1], 10);
  }

  function clock12(t, upper) {
    var p = String(t).split(':');
    var h = parseInt(p[0], 10);
    var m = parseInt(p[1], 10);
    var suffix = h % 24 >= 12 ? 'pm' : 'am';
    var hh = h % 12;
    if (hh === 0) hh = 12;
    var out = hh + ':' + (m < 10 ? '0' + m : m) + ' ' + suffix;
    return upper ? out.toUpperCase() : out;
  }

  function clockShort(t) {
    var p = String(t).split(':');
    var h = parseInt(p[0], 10);
    var m = parseInt(p[1], 10);
    var suffix = h % 24 >= 12 ? 'PM' : 'AM';
    var hh = h % 12;
    if (hh === 0) hh = 12;
    return hh + (m ? ':' + (m < 10 ? '0' + m : m) : '') + '\u00a0' + suffix;
  }

  function clock24(t) {
    var p = String(t).split(':');
    return parseInt(p[0], 10) + ':' + p[1];
  }

  function validRow(r) {
    return r && typeof r.day === 'number' && r.day >= 0 && r.day <= 6 && /^\d{2}:\d{2}$/.test(r.open) && /^\d{2}:\d{2}$/.test(r.close);
  }

  function groupWeek(rows) {
    var byDay = {};
    rows.forEach(function (r) {
      (byDay[r.day] = byDay[r.day] || []).push(r.open + '-' + r.close);
    });
    var groups = [];
    for (var d = 0; d < 7; d++) {
      if (!byDay[d]) continue;
      var sig = byDay[d].join(',');
      var last = groups[groups.length - 1];
      if (last && last.sig === sig && last.end === d - 1) {
        last.end = d;
      } else {
        groups.push({ sig: sig, start: d, end: d, spans: byDay[d] });
      }
    }
    return groups;
  }

  function dayLabel(g) {
    return g.start === g.end ? DAYS[g.start] : DAYS[g.start] + '–' + DAYS[g.end];
  }

  function spanText(spans, style) {
    return spans
      .map(function (s) {
        var p = s.split('-');
        if (style === 'contact') return clock24(p[0]) + ' – ' + clock24(p[1]);
        if (style === 'faq') return clock12(p[0], true) + ' to ' + clock12(p[1], true);
        return clock12(p[0]) + ' – ' + clock12(p[1]);
      })
      .join(', ');
  }

  function schemaFor(groups) {
    return groups.map(function (g) {
      var days = [];
      for (var d = g.start; d <= g.end; d++) days.push(DAYS[d]);
      return g.spans.map(function (s) {
        var p = s.split('-');
        return {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: days,
          opens: p[0],
          closes: p[1] === '24:00' ? '23:59' : p[1]
        };
      });
    }).reduce(function (all, list) {
      return all.concat(list);
    }, []);
  }

  function hasBookStore() {
    var nodes = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].textContent.indexOf('"BookStore"') !== -1 && !nodes[i].hasAttribute('data-bn-hours-ld')) return true;
    }
    return false;
  }

  function addMarkup(groups) {
    if (!hasBookStore() || document.querySelector('script[data-bn-hours-ld]')) return;
    var tag = document.createElement('script');
    tag.type = 'application/ld+json';
    tag.setAttribute('data-bn-hours-ld', '');
    tag.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BookStore',
      '@id': location.origin + '/#bookstore',
      openingHoursSpecification: schemaFor(groups)
    });
    document.head.appendChild(tag);
  }

  var DAY_RX = '(?:Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday)';
  var RANGE_RX = DAY_RX + '(?:\\s*[\\u2013-]\\s*' + DAY_RX + ')?';
  var SHAPES = [
    {
      style: 'lines',
      rx: new RegExp('^\\s*' + RANGE_RX + '\\s*:\\s*\\d{1,2}:\\d{2}\\s*[ap]m\\s*[\\u2013-]\\s*\\d{1,2}:\\d{2}\\s*[ap]m\\s*$', 'i')
    },
    {
      style: 'contact',
      rx: new RegExp('^\\s*' + RANGE_RX + '\\s*,\\s*\\d{1,2}:\\d{2}\\s*[\\u2013-]\\s*\\d{1,2}:\\d{2}\\s*\\(NPT\\)\\s*$', 'i')
    },
    {
      style: 'faq',
      rx: /^\s*(?:7 days a week[:,]?\s*)?[^<>]{0,140}\d{1,2}:\d{2}\s*[AP]M\s+to\s+\d{1,2}:\d{2}\s*[AP]M[^<>]{0,60}$/
    }
  ];

  function shapeOf(node) {
    if (!node || node.nodeType !== 3) return null;
    var text = node.nodeValue;
    if (!text || text.length > 220) return null;
    for (var i = 0; i < SHAPES.length; i++) {
      if (SHAPES[i].rx.test(text)) return SHAPES[i];
    }
    return null;
  }

  function findHours() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var found = [];
    var node;
    while ((node = walker.nextNode())) {
      var tag = node.parentNode && node.parentNode.nodeName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'TEXTAREA') continue;
      var shape = shapeOf(node);
      if (shape) found.push({ node: node, shape: shape });
    }
    return found;
  }

  function runFrom(first, shape) {
    var run = [first];
    var cur = first;
    for (;;) {
      var a = cur.nextSibling;
      var b = a && a.nextSibling;
      if (a && a.nodeName === 'BR' && b && b.nodeType === 3 && shape.rx.test(b.nodeValue)) {
        run.push(a, b);
        cur = b;
      } else if (a && a.nodeType === 3 && shape.rx.test(a.nodeValue)) {
        run.push(a);
        cur = a;
      } else {
        return run;
      }
    }
  }

  function render(groups, style) {
    var frag = document.createDocumentFragment();
    if (style === 'short') {
      var everyDay = groups.length === 1 && groups[0].start === 0 && groups[0].end === 6;
      groups.forEach(function (g, i) {
        if (i) frag.appendChild(document.createElement('br'));
        var label = everyDay ? 'Every day' : g.start === g.end ? SHORT_DAYS[g.start] : SHORT_DAYS[g.start] + '\u2013' + SHORT_DAYS[g.end];
        var spans = g.spans.map(function (sp) {
          var p = sp.split('-');
          return clockShort(p[0]) + ' \u2013 ' + clockShort(p[1]);
        }).join(', ');
        frag.appendChild(document.createTextNode(label + ' ' + spans));
      });
      return frag;
    }
    if (style === 'faq') {
      var openDays = groups.reduce(function (n, g) {
        return n + (g.end - g.start + 1);
      }, 0);
      var lead = openDays === 7 ? '7 days a week: ' : '';
      frag.appendChild(
        document.createTextNode(
          lead +
            groups
              .map(function (g) {
                return dayLabel(g) + ' ' + spanText(g.spans, 'faq');
              })
              .join(', ')
        )
      );
      return frag;
    }
    groups.forEach(function (g, i) {
      var sep = style === 'contact' ? ', ' : ': ';
      var tail = style === 'contact' ? ' (NPT)' : '';
      if (i) frag.appendChild(document.createElement('br'));
      frag.appendChild(document.createTextNode(dayLabel(g) + sep + spanText(g.spans, style) + tail));
    });
    return frag;
  }

  function apply(hours) {
    if (!Array.isArray(hours)) return;
    var rows = hours.filter(validRow);
    if (!rows.length) return;
    rows.sort(function (a, b) {
      return a.day - b.day || minutesOf(a.open) - minutesOf(b.open);
    });
    var groups = groupWeek(rows);
    var done = [];
    findHours().forEach(function (hit) {
      if (done.indexOf(hit.node) !== -1) return;
      var run = runFrom(hit.node, hit.shape);
      run.forEach(function (n) {
        done.push(n);
      });
      var parent = hit.node.parentNode;
      if (!parent) return;
      parent.insertBefore(render(groups, hit.shape.style), run[0]);
      run.forEach(function (n) {
        if (n.parentNode) n.parentNode.removeChild(n);
      });
    });
    addMarkup(groups);
    fillMarked(groups);
    watchMarked(groups);
  }

  function fillMarked(groups) {
    var list = document.querySelectorAll('[data-bn-hours="short"]:not([data-bn-dn-hours]):not([data-bn-hours-done])');
    for (var i = 0; i < list.length; i++) {
      list[i].setAttribute('data-bn-hours-done', '');
      list[i].replaceChildren(render(groups, 'short'));
    }
  }

  var watching = false;
  function watchMarked(groups) {
    if (watching || typeof MutationObserver === 'undefined') return;
    watching = true;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () {
        queued = false;
        fillMarked(groups);
      }, 50);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function cached() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var c = JSON.parse(raw);
      return c && Date.now() - c.at < CACHE_MS ? c.hours : null;
    } catch (e) {
      return null;
    }
  }

  function remember(hours) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), hours: hours }));
    } catch (e) {}
  }

  function run() {
    var hit = cached();
    if (hit) {
      apply(hit);
      return;
    }
    fetch(API, { credentials: 'omit' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        if (data && Array.isArray(data.hours) && data.hours.length) {
          remember(data.hours);
          apply(data.hours);
        }
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
